import { find } from 'lodash';

class RolesSelectController {

    constructor(rolesService) {
        this.rolesService = rolesService;
    }

    $onInit () {
        this.ngModel.$render = () => {
            if (this.roles && this.ngModel.$viewValue) {
                this.value = this.ngModel.$viewValue.map(value => find(this.roles, { value }));
            }
        };

        this.roles = this.rolesService.getRoles();
        this.ngModel.$render();
    }

    updateViewValue (isOpen = false) {
        if (!isOpen) {
            this.setValue();
            this.ngModel.$setTouched();
        }
    }

    setValue () {
        this.ngModel.$setViewValue(this.value.map(role => role.value));
    }
}

RolesSelectController.$inject = ['rolesService'];

export default RolesSelectController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/user/controllers/role.select.controller.js